import SystemNotificator from "../../services/SystemNotificator";
import client from "../../services/ApiClient";
import Vue from 'vue';
export const namespaced = true;

export const state = {

    emailAccounts: [],
    templates: [],
};

export const getters = {
    accounts(store) {
        return store.emailAccounts;
    },
};

export const mutations = {

    ADD_ACCOUNT(state, account) {
        state.emailAccounts.push(account)
    },

    UPDATE_ACCOUNT(state, {account, uuid}) {
        let storedAccount = state.emailAccounts.find(email => email.uuid === uuid);
        storedAccount.email = account.email;
        storedAccount.footer = account.footer;
    },

    DELETE_ACCOUNT(state, uuid) {
        const storedAccountIdx = state.emailAccounts.findIndex(email => email.uuid === uuid);
        state.emailAccounts.splice(storedAccountIdx, 1);
    },

    SET_ACCOUNTS(state, accounts) {
        state.emailAccounts = accounts;
    },

    UPDATE_TEMPLATE(state, payload) {
        let idx = state.templates.findIndex(t => t.uuid === payload.uuid);
        // dodaj nowy
        if (idx === -1) {
            state.templates.push(payload);
        } else {
            // zastąp istniejący
            Vue.set(state.templates, idx, payload);
        }
    },

    DELETE_TEMPLATE(state, uuid) {
        let idx = state.templates.findIndex(t => t.uuid === uuid);
        if (idx !== -1) {
            state.templates.splice(idx, 1);
        }
    }
};

export const actions = {

    updateAccount({rootGetters, commit}, {account, uuid}) {

        // jeśli przekazano uuid to aktualizujemy, w przeciwnym razie tworzymy nowe konto
        if (uuid) {

            return new Promise((resolve, reject) => {
                client.put('mailbox/'.concat(uuid), account)
                    .then(() => {
                        commit('UPDATE_ACCOUNT', {account, uuid});
                        SystemNotificator.success({title: '', message: 'Konto zostało zaktualizowane'});
                        resolve();
                    })
                    .catch(error => {
                        SystemNotificator.error({
                            title: 'Błąd podczas aktualizacji konta',
                            message: error.response.data.errors
                        });
                        reject();
                    })
                ;
                });

        } else {
            return new Promise((resolve, reject) => {
                client.post('mailbox/box', account)
                    .then(({data}) => {
                        if (data.data) {
                            commit('ADD_ACCOUNT', {
                                uuid: data.data.uuid,
                                email: account.email,
                                footer: account.footer,
                                ownerUuid: rootGetters['Auth/user'].uuid,
                            });
                            SystemNotificator.success({title: '', message: 'Konto zostało dodane'});
                            resolve();
                        }
                    })
                    .catch(error => {
                        SystemNotificator.error({title: 'Błąd podczas dodawania konta', message: error.response.data.errors});
                        reject();
                    })
                ;
            });
        }
    },

    deleteAccount({commit}, uuid) {
        return client.delete('mailbox/'.concat(uuid))
            .then(() => {
                commit('DELETE_ACCOUNT', uuid);
                SystemNotificator.success({title: 'Konto zostało usunięte'});
            })
            .catch(() => {
                SystemNotificator.error({title: 'Błąd. Konto nie zostało usunięte'});
            })
            ;
    },

    fetchAccounts({commit}) {
        return client.get('mailbox/box')
            .then(({data}) => {
                if (Array.isArray(data.data)) {
                    commit('SET_ACCOUNTS', data.data)
                }
            })
            .catch(() => {

            })
    },

    fetchConfig(context, uuid) {
        return client.get('mailbox/config/'.concat(uuid))
    },

    fetchTemplates({commit}) {

        return client.get('/mailbox/template')
            .then(({data}) => {
                if (Array.isArray(data.data)) {
                    for (let template of data.data) {
                        commit('UPDATE_TEMPLATE', template)
                    }
                }
            })
    },

    fetchTemplateDetails(context, uuid) {
        return client.get(`/mailbox/template/${uuid}`);
    },

    saveTemplate({commit, rootGetters}, payload) {
        let fn = client.post,
            uuid = '';

        if (payload.uuid !== '') {
            fn = client.put;
            uuid = `/${payload.uuid}`
        }

        return new Promise((resolve, reject) => {
            fn('/mailbox/template'.concat(uuid),
                payload.data
            )
                .then(({data}) => {
                    if (data) {
                        commit('UPDATE_TEMPLATE', {
                            uuid: data.data.uuid,
                            title: payload.data.title,
                            ownerUuid: rootGetters['Auth/user'].uuid,
                        })
                    }
                    SystemNotificator.success({title: '', message: (uuid.length > 0 ? 'Szablon został zaktualizowany' : 'Szablon został utworzony')});
                    resolve(data);
                })
                .catch((error) => {
                    SystemNotificator.error({title: 'Błąd', message: error.response.data.errors});
                    reject(error);
                });
        });
    },

    deleteTemplate({commit}, uuid) {
        return client.delete(`/mailbox/template/${uuid}`)
            .then(() => {
                commit('DELETE_TEMPLATE', uuid)
            })
        ;
    }

};